export default "__VITE_ASSET__CnEmBN5V__"